import { ILink } from '../../../types/links';
import { LinkContainer } from '../../../containers/links/LinkContainer';

export const vacancies: ILink = {
  component: LinkContainer,
};
